// ─────────────────────────────────────────────────────────────────────────────
// PagesSheetContent.tsx — "Pages" mobile sheet: site nav + framework switcher
// ─────────────────────────────────────────────────────────────────────────────

import { NavLink } from 'react-router-dom';
import { useAppDispatch } from '@/hooks';
import { setFrontEndFramework } from '@/store/uiSlice';
import { FE_FRAMEWORKS, frameworkHref, frameworkBadge } from '@/data/navOptions';

export function PagesSheetContent() {
  const dispatch = useAppDispatch();

  return (
    <div className="flex flex-col gap-1 px-2 pb-4">
      <p className="px-3 pt-3 pb-1 text-xs font-semibold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
        Pages
      </p>
      <NavLink to="/"         className="nav-link px-3 py-3 rounded-xl hover:bg-slate-50 dark:hover:bg-navy-800">CV</NavLink>
      <NavLink to="/patterns" className="nav-link px-3 py-3 rounded-xl hover:bg-slate-50 dark:hover:bg-navy-800">Design Patterns</NavLink>
      <NavLink to="/docker"   className="nav-link px-3 py-3 rounded-xl hover:bg-slate-50 dark:hover:bg-navy-800">MongoDB in Docker</NavLink>
      <NavLink to="/projects" className="nav-link px-3 py-3 rounded-xl hover:bg-slate-50 dark:hover:bg-navy-800">Projects</NavLink>

      <p className="px-3 pt-4 pb-1 text-xs font-semibold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
        Switch Framework
      </p>
      {FE_FRAMEWORKS.map((f) => {
        const isCurrent = f.value === 'react-redux';
        const badge = frameworkBadge(f, isCurrent);
        return (
          <a
            key={f.value}
            href={frameworkHref(f)}
            onClick={() => dispatch(setFrontEndFramework(f.value))}
            className="flex items-center justify-between px-3 py-3 rounded-xl hover:bg-slate-50 dark:hover:bg-navy-800 text-slate-700 dark:text-slate-300 transition-colors"
          >
            <span className="text-sm">{f.label}</span>
            {badge && (
              <span
                className={`text-xs px-2 py-0.5 rounded-full font-medium font-mono ${
                  isCurrent ? 'bg-accent-soft-20 text-accent' : 'bg-slate-100 dark:bg-navy-700 text-slate-500 dark:text-slate-400'
                }`}
              >
                {badge}
              </span>
            )}
          </a>
        );
      })}
    </div>
  );
}
